/**
 * Conteúdo do `additionalData[0]` dos serviços da esteira que falam o
 * protocolo novo (contrato C3/C9). Campos que o provedor não devolveu chegam
 * `null` — tudo aqui é opcional/anulável de propósito.
 */

export interface IScoreRestriction {
  qtd?: number | null;
  total?: number | null;
}

export interface IScoreData {
  kind: 'score';
  tipo?: 'PF' | 'PJ' | null;
  classe?: string | null;
  pontos?: number | null;
  faixa?: string | null;
  probabilidade?: string | null;
  restricoes?: {
    debitos?: IScoreRestriction | null;
    protestos?: IScoreRestriction | null;
    /** `qtd` nulo = o provedor não informou (não é o mesmo que zero). */
    cheques?: { qtd?: number | null } | null;
  } | null;
  /** Renda presumida (PF) ou faturamento estimado (PJ). */
  renda?: number | null;
  consultadoEm?: string | null;
}

export interface ICompanyPartner {
  nome?: string | null;
  documento?: string | null;
  dataEntrada?: string | null;
}

export interface ICompanyAddress {
  logradouro?: string | null;
  numero?: string | null;
  complemento?: string | null;
  bairro?: string | null;
  cidade?: string | null;
  uf?: string | null;
  cep?: string | null;
}

export interface ICompanyPhone {
  numero?: string | null;
  tipo?: 'fixo' | 'movel' | string | null;
}

export interface ICompanyData {
  kind: 'dados_pj';
  razaoSocial?: string | null;
  nomeFantasia?: string | null;
  dataAbertura?: string | null;
  idadeEmpresa?: number | string | null;
  situacaoCadastral?: string | null;
  dataSituacaoCadastral?: string | null;
  porte?: string | null;
  naturezaJuridica?: string | null;
  cnae?: {
    codigo?: number | string | null;
    descricao?: string | null;
  } | null;
  socios?: ICompanyPartner[] | null;
  enderecos?: ICompanyAddress[] | null;
  telefones?: ICompanyPhone[] | null;
  emails?: string[] | null;
}

export interface IRegistrationData {
  kind: 'validacao_pj';
  razaoSocial?: string | null;
  situacaoCadastral?: string | null;
  dataSituacaoCadastral?: string | null;
}

export type KindData = IScoreData | ICompanyData | IRegistrationData;

export const KNOWN_KINDS = ['score', 'dados_pj', 'validacao_pj'] as const;
export type KnownKind = typeof KNOWN_KINDS[number];

/**
 * `kind` do item de resultado, quando é de um serviço do protocolo novo. É
 * por ele (e não pelo nome do serviço, que pode vir nulo) que a tela decide
 * como mostrar o conteúdo.
 */
export const kindOf = (item: {
  additionalData?: Array<{ kind?: string }>;
}): KnownKind | undefined => {
  const kind = item.additionalData?.[0]?.kind;
  return (KNOWN_KINDS as readonly string[]).includes(kind ?? '')
    ? (kind as KnownKind)
    : undefined;
};
